import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * 公用icon模块
 */
class Iconfont extends Component {
  static propTypes = {
    style: PropTypes.object,
    children: PropTypes.any.isRequired
  };
  render() {
    const { style, children, ...props } = this.props;
    return (
      <i className="iconfont" style={style} {...props}>
        {children}
      </i>
    );
  }
}

export default Iconfont;



// WEBPACK FOOTER //
// ./src/pages/components/Iconfont/index.js